import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ContractTypeService } from '@app/services/contract-type.service';
import { GlobalUtil } from '@app/modules/common/shared/util/global-util';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { SidebarService } from '@services/sidebar.service';
@Component({
  selector: 'app-contract-type-form',
  templateUrl: './contract-type-form.component.html',
  styleUrls: [],
  providers: [SidebarService]
})

export class ContractTypeFormComponent extends BaseComponent {
  // Local variables
  contractTypeFormGroup: FormGroup;
  dataLoaded = false;
  globalUtil = GlobalUtil;

  // Contractor
  constructor(
    public activatedRoute: ActivatedRoute,
    public contractTypeService: ContractTypeService,
    public sidebarService: SidebarService,
    public state: State,
    private formBuilder: FormBuilder
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService: sidebarService,
      state: state,
      modelService: contractTypeService
    });

    this.setPageVars({
      sidebar: ''
    });

    this.initialFormGroupSetup();
    const id = this.routeParams['id'];
    if (id === undefined) {
      this.dataLoaded = true;
    } else {
      this.modelService.getOne(id).subscribe((result: any) => {
        this.dataLoaded = true;
        this.contractTypeFormGroup.patchValue(result);
      });
    }
  }

  // All the public methods
  get controls(): any {
    return this.contractTypeFormGroup.controls;
  }

  public save(): void {
    const id = this.controls.id.value;
    const uuid = this.controls.uuid.value;
    if (id || uuid) {
      // Update the existing row
      this.contractTypeService.patchById(uuid ? uuid : id, this.contractTypeFormGroup.value)
        .subscribe(result => {
          this.SavedMessage(result);
        });
    } else {
      // Create the new row
      this.contractTypeService.create(this.contractTypeFormGroup.value).subscribe(result => this.SavedMessage(result));
    }
  }

  // All the private methods
  private initialFormGroupSetup(): void {
    // setup the initial form for row entity
    this.contractTypeFormGroup = this.formBuilder.group({
      uuid: [null],
      id: [null],
      name: [null, [Validators.required, Validators.maxLength(GlobalUtil.Validation.GENERAL_FIELD_MAX_LENGTH)]]
    });
  }

  private SavedMessage(data) {
    this.state.message({ ['ContractTypeIndexUpdate']: true });
    this.closeSlideout();
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
